import { createSelector } from '@ngrx/store';

import type { PickActions } from '@core/ngrx-legacy';
import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  memoizeSelector,
} from '@core/ngrx-legacy';
import type { DataSource } from '@recruitee/views-types';

const idSelector = (entity: { id: string }) => entity.id;
const { actions, selectors, reducer, namespace } = createEntityCollectionStore<DataSource>()(
  'ViewsDataSource',
  {
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);

      return {
        fetchOne: (state, payload: { id: string }) => defaultActions.fetchOne(state, payload),
      };
    },
  },
);

export const DataSourceSelectors = {
  ...selectors,
  filtersMapById: memoizeSelector((id: string) =>
    createSelector(selectors.byId(id), dataSource =>
      dataSource ? Object.fromEntries(dataSource.filters.map(filter => [filter.id, filter])) : null,
    ),
  ),
};
export const DataSourceActions: PickActions<typeof actions, 'fetchOne'> = actions;
export { reducer as DataSourceReducer, namespace as DataSourceNamespace };
